import React from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import styles from "./Inputs.module.scss";

const PhoneInputComponent = ({ label, value, onChange, placeholder,required}) => {
  return (
    <div className={styles.inputContainer}>
      <label className={styles.label}>
        {label} 
        {required&&<span className={styles.required}>*</span>}
      </label>
      <PhoneInput
        value={value}
        onChange={onChange}
        defaultCountry="ES"
        placeholder={placeholder}
        className={styles.phoneInput}
      />
    </div>
  );
};

export default PhoneInputComponent;
